import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnFormFieldGroupWrapperConfig } from '@lib/form/form-field-group';

export type SnFormFieldConfig = FormlyFieldConfig | ISnFormFieldGroupWrapperConfig;
